// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"252":"3f253e3e95020064b830","525":"c4b9e46d91cc86c66206","561":"9bde72a40a9d0dd09d10"}[chunkId] + ".js";
};